import { type ComponentPropsWithoutRef, forwardRef } from "react";
import { Icon } from "../components/icon";
import { Input } from "../components/input";
import { cn } from "../lib/utils";

export interface SearchInputProps extends ComponentPropsWithoutRef<"input"> {
  inputClassName?: string;
  onReset?: () => void;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, inputClassName, value, onReset, ...props }, ref) => {
    return (
      <div className={cn("relative", className)}>
        <Input type="text" className={cn("pl-8 pr-8", inputClassName)} ref={ref} value={value} {...props} />
        <Icon name="search" className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-textPrimary" />
        {value !== "" && onReset != null ? (
          <button
            type="button"
            onClick={onReset}
            className="absolute right-4 top-1/2 -translate-y-1/2 py-2 pl-2 text-textSubtle hover:text-textDefault transition-colors"
          >
            <Icon name="close" className="size-3" />
          </button>
        ) : null}
      </div>
    );
  },
);

SearchInput.displayName = "SearchInput";
